<template>
  <base-dialog v-model="isVisibleReportList">
    <dialog-template>
      <flat-list-skeleton-loader slot="content" :loading="loading">
        <div>
          <template-preview
            :class="$style.template"
            :title="$t('new.report')"
            is-new
            @edit="handleEdit"
          />
          <div
            v-for="template in templates"
            :key="template.id"
            :class="$style.template"
          >
            <template-preview
              :title="template.name"
              @edit="handleEdit(template)"
              @delete="handleDelete(template)"
              @rename="handleRename(template)"
            />
          </div>
        </div>
      </flat-list-skeleton-loader>
    </dialog-template>
  </base-dialog>
</template>

<script>
import { mapMutations } from 'vuex';

import BaseDialog from 'molecules/base/Dialog';
import FlatListSkeletonLoader from 'organisms/skeleton/FlatListSkeletonLoader';
import DialogTemplate from 'templates/DialogTemplate';

import TemplatePreview from './components/TemplatePreview';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'ReportTemplateListDialog',
  components: {
    BaseDialog,
    FlatListSkeletonLoader,
    DialogTemplate,
    TemplatePreview,
  },
  props: {
    templates: {
      type: Array,
      required: true,
    },
    loading: Boolean,
  },
  created() {
    EVENT_BUS.$on('EVENT_SHOW_REPORT_LIST', this.showReportList);
    EVENT_BUS.$on('EVENT_HIDE_REPORT_LIST', this.hideReportList);
  },

  destroyed() {
    EVENT_BUS.$off('EVENT_SHOW_REPORT_LIST', this.showReportList);
    EVENT_BUS.$off('EVENT_HIDE_REPORT_LIST', this.hideReportList);
  },
  data() {
    return {
      isVisibleReportList: false,
    };
  },
  methods: {
    showReportList() {
      this.isVisibleReportList = true;
    },
    hideReportList() {
      this.isVisibleReportList = false;
    },
    handleEdit(template) {
      this.$emit('edit', template);
      this.isVisibleReportList = false;
    },
    handleDelete(template) {
      this.$emit('delete', template.id);
    },
    handleRename(template) {
      this.SET_CURRENT_EDITING_TEMPLATE(template);
      EVENT_BUS.$emit('EVENT_RENAME_REPORT_TEMPLATE');
    },
    ...mapMutations('reports', ['SET_CURRENT_EDITING_TEMPLATE']),
  },
};
</script>

<style lang="sass" module>
  .template
    margin-bottom: 10px

    &:last-child
      margin-bottom: 0
</style>
